import { uuid } from "../uuid";

export const conf2AccountId = uuid;
